"use strict";
var isObject = require("../internals/is-object");
var floor = Math.floor;
module.exports = Number.isInteger || function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};
